import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move",
  "use": "move-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"move\">\n<path d=\"M9 1.5L6.75 3.59999H8.43749V6.75H9.56251V3.59999H11.25L9 1.5Z\" />\n<path d=\"M9 16.5L11.25 14.4H9.56251V11.25H8.43749V14.4H6.75L9 16.5Z\" />\n<path d=\"M16.5 9L14.4 6.75V8.43749H11.25V9.56251H14.4V11.25L16.5 9Z\" />\n<path d=\"M1.5 9L3.59999 11.25V9.56251H6.75V8.43749H3.59999V6.75L1.5 9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol